import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PrinterStatusMessage } from '../../knowledge/lane-control.knowledge';

@Component({
  selector: 'app-printer-viewer',
  templateUrl: './printer-viewer.component.html',
  styleUrls: ['./printer-viewer.component.scss'],
})
export class PrinterViewerComponent implements OnInit {
  @Input() printerId: any;
  @Input() printerIndex: any;
  @Input() position: any;
  @Input() printerStatus: any;
  @Input() sensorsState: any;
  /**
   * Update error event
   */
  // tslint:disable-next-line:no-output-rename
  @Output('updatePrinterError') updatePrinterErrorEvent: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  errorClass(status: string) {
    let statusClass = '';
    if (status === PrinterStatusMessage.Online || status === PrinterStatusMessage.LoadingPrinting) {
      statusClass = 'text-ok';
      this.updatePrinterError('ok');
    } else if (status === PrinterStatusMessage.NearPaperEnd) {
      this.updatePrinterError('alert');
      statusClass = 'text-alert';
    } else if (
      status === PrinterStatusMessage.TicketHoldInMouth ||
      status === PrinterStatusMessage.LFKey ||
      status === PrinterStatusMessage.FFKey ||
      status === PrinterStatusMessage.NotchFound
    ) {
      statusClass = 'text-warning';
      this.updatePrinterError('warning');
    } else {
      this.updatePrinterError('error');
      statusClass = 'text-error';
    }
    return statusClass;
  }

  updatePrinterError(status: string) {
    this.updatePrinterErrorEvent.emit({ status });
    // console.log('printerErrorStatu printer-viewer ' + status);
  }
}
